import React, { memo, useMemo } from 'react';
import { FormattedNumber } from 'react-intl';

import Spin from 'components/Spin';
import { VERTICAL_URL } from 'settings';
import { Mask } from 'v2/components/Shared/ValuesVisibility';
import { useElite } from 'v2/hooks/useElite';

import EliteProgressBar from './EliteProgressBar';

const EliteCard = memo(() => {
  const eliteListQuery = useElite();
  const { data, error } = eliteListQuery;

  const producerGains = useMemo(() => data?.gains_producer || 0, [data]);
  const affiliateGains = useMemo(() => data?.gains_affiliate || 0, [data]);
  const totalGains = useMemo(() => producerGains + affiliateGains, [affiliateGains, producerGains]);

  const isLoading = data === null && error == undefined;

  return (
    <div className='h-full rounded-sm border border-gray-100 bg-white p-4 shadow-sm'>
      {isLoading ? (
        <Spin />
      ) : (
        <div className='flex h-full flex-col justify-between'>
          <div>
            <div className='mb-4 flex items-center justify-between'>
              <div>
                <h6 className='text-xl font-medium'>Elite</h6>
                <p className='text-sm text-gray-500'>Resumo de seus ganhos líquidos e faixa elite</p>
              </div>

              <div>
                {producerGains >= 100000 && data?.progress?.producer.current ? (
                  <img
                    className='h-[50px] w-[50px]'
                    src={`https://cdn.eduzzcdn.com/badges/${
                      data?.progress?.producer?.current?.has_plus
                        ? `${data.progress.producer.current.badge_elite}-plus.svg`
                        : `${data.progress.producer.current.badge_elite}.svg`
                    }`}
                    alt={`Badge ${data.progress.producer.current.name}`}
                  />
                ) : null}
              </div>
            </div>

            <div>
              <EliteProgressBar producerGains={producerGains} />
            </div>

            <div className='mt-4 flex flex-col gap-3'>
              <div className='flex flex-col'>
                <span className='text-right text-base'>Ganhos como produtor/coprodutor:</span>
                <span className='text-right text-2xl font-normal'>
                  <Mask>
                    <FormattedNumber value={producerGains} format='BRL' />
                  </Mask>
                </span>
              </div>

              <div className='flex flex-col'>
                <span className='text-right text-base'>Ganhos como afiliado/coafiliado:</span>
                <span className='text-right text-2xl font-normal'>
                  <Mask>
                    <FormattedNumber value={affiliateGains} format='BRL' />
                  </Mask>
                </span>
              </div>

              <div className='flex flex-col'>
                <span className='text-right text-base'>Total de ganhos:</span>
                <span className='text-right text-2xl font-normal'>
                  <Mask>
                    <FormattedNumber value={totalGains} format='BRL' />
                  </Mask>
                </span>
              </div>
            </div>
          </div>

          <a style={{ fontSize: 14 }} href={`${VERTICAL_URL}/dashboard-elite`} target='_blank' rel='noreferrer'>
            Ver detalhes do programa elite
          </a>
        </div>
      )}
    </div>
  );
});

export default EliteCard;
